// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable i18next/no-literal-string */
import { EVENT_DELAY } from '@src/config/constants'
import {
  CONFIG_KEY_GOOGLE_ADS_GA4_TRACKING_ID,
  CONFIG_KEY_GOOGLE_ADS_TRACKING_ID,
  CONFIG_KEY_GOOGLE_GTM_SERVER_CONTAINER_ID,
  CONFIG_KEY_GOOGLE_GTM_SERVER_CONTAINER_URL,
} from '@src/config/env'
import { initializeScript } from '@src/telemetry/integrations/provider-utils/initialize-script'
import { TelemetryIntegration } from '@src/telemetry/telemetry-events.types'
import { executeFireAndForgotTask } from '@src/utils/fire-and-forgot-task'

import { TELEMETRY_DOMAINS } from '../telemetry-domains.constants'
import { TELEMETRY_EVENT_NAMES } from '../telemetry-events.constants'

import TrustArcCl from './trustarc'
export const initGtag = () => {
  if (window.gtag) {
    return
  }
  window.dataLayer = window.dataLayer ?? []
  window.gtag = function gtag(...args) {
    if (window.dataLayer) {
      window.dataLayer.push(args)
    }
  }
  window.gtag('js', new Date())
  window.gtag('config', CONFIG_KEY_GOOGLE_ADS_GA4_TRACKING_ID)
  window.gtag('config', CONFIG_KEY_GOOGLE_GTM_SERVER_CONTAINER_ID, {
    server_container_url: CONFIG_KEY_GOOGLE_GTM_SERVER_CONTAINER_URL,
  })
}

const initGtagAds = () => {
  if (!window.gtag) {
    window.gtag = function gtag(...args) {
      if (window.dataLayer) {
        window.dataLayer.push(args)
      }
    }
  }
  window.gtag('config', CONFIG_KEY_GOOGLE_ADS_TRACKING_ID)
}

export const GoogleAdsTag: TelemetryIntegration = {
  config: {
    enabled: true,
    eventIdealTimeout: 1000,
    domain: TELEMETRY_DOMAINS.GOOGLE_TAG_MANAGER,
    featureGateName: 'ssr_telemetry_google_ads_tag',
  },

  initialize: async () => {
    if (!TrustArcCl.hasAllowedAdvertisingTrackerConsent()) {
      return
    }
    initGtagAds()
    await initializeScript({
      key: 'google-ads-ga4',
      domain: TELEMETRY_DOMAINS.GOOGLE_TAG_MANAGER,
      path: `/gtag/js?id=${CONFIG_KEY_GOOGLE_ADS_TRACKING_ID}`,
      injectAt: 'beforeFirstScript',
    })
  },

  events: {
    [TELEMETRY_EVENT_NAMES.PAGE_VIEW]: () => {
      executeFireAndForgotTask(() => {
        if (window.gtag) {
          window.gtag('event', 'conversion', {
            send_to: 'AW-773421270/4AphCOWJ7JQBENbx5fAC',
            value: 0.0,
          })
        }
      }, EVENT_DELAY)
    },

    [TELEMETRY_EVENT_NAMES.PRODUCT_VIEW](properties) {
      executeFireAndForgotTask(() => {
        if (window.gtag) {
          window.gtag('event', 'conversion', {
            send_to: 'AW-773421270/yJGDCOuJ7JQBENbx5fAC',
            value: properties.price ? formatRevenue(Number(properties.price)) : 0.0,
          })
        }
      }, EVENT_DELAY)
    },

    [TELEMETRY_EVENT_NAMES.ADD_TO_CART]: properties => {
      executeFireAndForgotTask(() => {
        if (window.gtag) {
          window.gtag('event', 'conversion', {
            send_to: 'AW-773421270/cdIiCO6J7JQBENbx5fAC',
            value: properties.price ? formatRevenue(Number(properties.price)) : 0.0,
          })
        }
      }, EVENT_DELAY)
    },

    [TELEMETRY_EVENT_NAMES.SEARCH]: () => {
      executeFireAndForgotTask(() => {
        if (window.gtag) {
          window.gtag('event', 'conversion', {
            send_to: 'AW-773421270/6lZuCPSJ7JQBENbx5fAC',
            value: 0.0,
          })
        }
      }, EVENT_DELAY)
    },
    [TELEMETRY_EVENT_NAMES.JOIN_THE_WAITLIST]: () => {
      executeFireAndForgotTask(() => {
        if (window.gtag) {
          window.gtag('event', 'conversion', {
            send_to: 'AW-773421270/FFOjCMbGqpAYENbx5fAC',
          })
        }
      }, EVENT_DELAY)
    },
  },
}

export const formatRevenue = (price: number | null): number => {
  if (price != null) {
    return price
  }
  return 0
}
